/** Community slug values aligned with backend CommunityConstants. */
export const COMMUNITY_SLUGS = {
  HIGHLIGHT: 'highlight',
  GOOD_HOUSEKEEPING_MEMBERSHIP: 'goodhousekeeping-membership',
  ACME_GRAVITAS: 'acme-gravitas',
} as const;

export type CommunitySlug = (typeof COMMUNITY_SLUGS)[keyof typeof COMMUNITY_SLUGS];
